<mat-card appearance="outlined" class="mat-card--no-content-padding">
  <mat-card-header class="mat-card-header-with-action">
    <mat-card-title>
      <span>{{ 'PROJECT_LIST_CARD.TITLE' | translate }}</span>
    </mat-card-title>
  </mat-card-header>
  <mat-divider></mat-divider>
  <ng-container *ngIf="isEmptyState$ | async; else listProjects">
    <mat-card-content>
      <glxy-empty-state [size]="'small'" style="padding: 16px">
        <glxy-empty-state-hero>
          <mat-icon>checklist</mat-icon>
        </glxy-empty-state-hero>
        <p>{{ 'PROJECT_LIST_CARD.NO_PROJECTS' | translate }}</p>
      </glxy-empty-state>
    </mat-card-content>
  </ng-container>
  <mat-card-actions *ngIf="showViewAll$ | async" align="end">
    <a mat-button color="primary" (click)="goToAccountProjectList()">{{ 'PROJECT_LIST_CARD.VIEW_ALL' | translate }}</a>
  </mat-card-actions>
</mat-card>

<ng-template #listProjects>
  <mat-list>
    <mat-list-item *ngFor="let project of projects$ | async" style="height: 100%">
      <div class="project">
        <glxy-avatar class="project-icon" icon="checklist" [backgroundColor]="projectsIconGreen"></glxy-avatar>
        <div class="project-info">
          <div class="project-description">
            <a color="primary" (click)="goToProjectDetail(project)">
              {{ project.title }}
            </a>
            <div *ngIf="project.status !== status.COMPLETED" class="project-status-date">
              {{ 'PROJECT_LIST_CARD.DUE_DATE' | translate : { dueDate: project.dueDate | glxyDate } }}
            </div>
            <div *ngIf="project.status === status.COMPLETED" class="project-status-date">
              {{
                'PROJECT_LIST_CARD.COMPLETED_DATE' | translate : { completedDate: project.completionDate | glxyDate }
              }}
            </div>
          </div>
          <div class="project-status" *ngIf="project.status">
            <glxy-badge
              *ngIf="
                (project.dueDate | overdue : false) !== ('COMMON.DUE.OVERDUE' | translate) ||
                  project.status === status.COMPLETED;
                else overDueText
              "
              class="project-status-badge"
              [color]="getStatusBadgeColor(project.status)"
            >
              {{ project.status | projectStatus }}
            </glxy-badge>
            <ng-template #overDueText>
              <glxy-badge class="project-status-badge" [color]="'yellow'">
                {{ project.dueDate | overdue : false }}
              </glxy-badge>
            </ng-template>
            <button
              mat-icon-button
              class="start-conversation-button"
              color="primary"
              data-action="clicked-send-message-icon_project-card"
              (click)="sendMessage(project)"
            >
              <mat-icon>question_answer</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </mat-list-item>
  </mat-list>
  <glxy-loading-spinner
    *ngIf="loadingProjects$ | async"
    [size]="'default'"
    [fullWidth]="true"
    [fullHeight]="true"
    [inline]="false"
    [class.show-border-and-background]="true"
  ></glxy-loading-spinner>
</ng-template>
